// import './css/service-edit.css';

import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';

import API from 'service/api';
import Util, { ActionType } from 'service/util';

import Form from 'component/Form';
import PopMessage from 'component/pop-msg/PopMessage';

import ModalScreen from 'component/ModalScreen';

class SuspendServiceModal extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      min_dtm: new Date(props.min_dtm),
      max_dtm: new Date(),
      start_dtm: new Date(),
      end_dtm: null,
      reason_id: 0,
      remarks: '',
      error: '',
    }
    this.submitModal = this.submitModal.bind(this);
  }

  setStartDate(start_dtm)
  {
    this.setState({start_dtm});
  }
  setEndDate(end_dtm)
  {
    this.setState({end_dtm});
  }

  get minRestartDate()
  {
    if (!this.state.start_dtm)
      return null;
    else
    {
      let refDate = new Date();
      refDate = new Date(moment(this.state.start_dtm).valueOf());
      refDate.setHours(24,0,0,0);
      return refDate;
    }
  }

  submitModal(e)
  {
    e.preventDefault();
    e.stopPropagation();

    let service = {...this.props.service, action: ActionType.Suspend};
    service.ori_dtm   = Util.ShortDate(service.start_dtm);
    service.start_dtm = Util.ShortDate(this.state.start_dtm);
    service.end_dtm   = Util.ShortDate(this.state.end_dtm);
    service.remarks   = this.state.remarks;
    service.reason_id = this.state.reason_id;

    API.changeServiceRecord(service).then(resp =>
    {
      if (!resp.success)
        PopMessage.show(resp.msg, '資料存取失敗', 'danger');
      else
      {
        PopMessage.show('已存儲暫停服務記錄', '成功', 'success');
        this.props.onUpdatedService(resp.msg);
        this.props.closeModal();
      }
    });

    return false;
  }

  render()
  {
    const v = this.props.vehicle;
    return (
      <ModalScreen className="sem sem-suspend" show={true}
        title={`暫停車輛服務 - ${v.cd_license}`}
        onClose={this.props.closeModal}>
        <Form className="sem-form" onSubmit={this.submitModal}>

          <label className="field">
            <strong>服務暫停日</strong>
            <DatePicker selected={this.state.start_dtm} onChange={d=>this.setStartDate(d)} required
                        dateFormat="yyyy-MM-dd" minDate={ this.state.min_dtm } />
          </label>
          <label className="field">
            <strong>服務重啟日</strong>
            <DatePicker selected={this.state.end_dtm} onChange={d=>this.setEndDate(d)} required
                        dateFormat="yyyy-MM-dd" minDate={this.minRestartDate} />
          </label>
          <label className="field">
            <strong>暫停原因</strong>
            <select value={this.state.reason_id} onChange={e=>this.setState({reason_id: parseInt(e.target.value,10)})}>
              <option value="1">無抹</option>
              <option value="5">搬屋</option>
              <option value="2">離港/不用車</option>
              <option value="3">撞車</option>
              <option value="0">其他</option>
            </select>
          </label>
          <label className="field">
            <strong>原因備註</strong>
            <input type="text" value={this.state.remarks} onChange={e=>this.setState({remarks: e.target.value })}/>
          </label>

          <div className="error-msg">
            { this.state.error }
          </div>
          <div className="action-panel">
            <button className="btn grey" type="button"
                    onClick={e=>this.props.closeModal()}>關閉</button>
            <button id="btn-submit" className="btn blue" >確定</button>
          </div>
        </Form>
      </ModalScreen>
    );
  }

}


export default SuspendServiceModal;